import versionJson from "@coworker/functions/src/version.json";

export function versionFixa() {
  return versionJson.version;
}
